import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Polar } from './polar';
import { Parallel } from './parallel';
/**
 *  Radar = Parallel + Polar.
 */
export var Radar = function Radar(options) {
  var _options$startAngle = options.startAngle,
    startAngle = _options$startAngle === void 0 ? -Math.PI / 2 : _options$startAngle,
    _options$endAngle = options.endAngle,
    endAngle = _options$endAngle === void 0 ? Math.PI * 3 / 2 : _options$endAngle,
    _options$innerRadius = options.innerRadius,
    innerRadius = _options$innerRadius === void 0 ? 0 : _options$innerRadius,
    _options$outerRadius = options.outerRadius,
    outerRadius = _options$outerRadius === void 0 ? 1 : _options$outerRadius;
  return [].concat(_toConsumableArray(Parallel()), _toConsumableArray(Polar({
    startAngle: startAngle,
    endAngle: endAngle,
    innerRadius: innerRadius,
    outerRadius: outerRadius
  })));
};
Radar.props = {};